import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import { Grid, Select, Tooltip, Typography } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import engagementIcon from "../../../../../assets/svg/dashboard/engagement-summary.svg";

import ChatBoxModal from "../../../../common/chatBoxModal";
import { useWindowDimensions } from "../../../../common/windowsize";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const useStyles = makeStyles(theme => ({
  table: {
    [theme.breakpoints.down('md')]: {
      overflowX: 'hidden'
    }
  },
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
   
    [theme.breakpoints.down('md')]: {
      display: 'flex', 
      justifyContent: 'right', 
      textAlign: 'right', 
      position: 'relative', 
      paddingLeft: '100px', 
      fontSize: '13px'
    }
  },
  tableHeader: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    color: "#212529",
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
      position: 'absolute', 
      left: '16px', 
      top: '16px', 
      width: '50px',
      textAlign: 'left', 
      fontSize: '12px'
    }
  },
  root: {
    marginBottom: "30px",
    [theme.breakpoints.down('md')]: {
      overflowX: 'hidden'
    }
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
}));

export default function BasicTable(props) {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const history = useHistory();
  const classes = useStyles();
  const [chatdata, setChatData] = useState();
  const [chatId, setChatId] = useState();
  const { data } = props;
  const dimension = useWindowDimensions()
  const small = dimension.width < 500;

  const HeaderItem = (props) => {
    return small ? (
      <div className={classes.tableHeader}>{props.t}</div>
    ) : ""
  }

  return (
    <Box className={classes.root}>
      {props.data?.length > 0 ? (
        <TableContainer className={classes.table} component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          {!small && <TableHead>
            <TableRow>
              <TableCell
                className={[clsx(classes.tableRightBorder, classes.tableHeader,"tableJustify fixColumbnWidth4")]}
              >
                NO.
              </TableCell>
              <TableCell
                colSpan={2}
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                MENTOR
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                DESIGNATION
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                COMPANY
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                CITY
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                SEND MESSAGE
              </TableCell>
              <TableCell
                className={clsx(classes.tableRightBorder, classes.tableHeader)}
              >
                MENTORSHIP
              </TableCell>
            </TableRow>
          </TableHead>}
          
          <TableBody>
            {data?.map((datum, index) => (
              <TableRow key={index} style={dimension.width < 500 ? {display: 'flex', flexDirection: 'column'} : {}}>
                <TableCell
                  className={clsx(classes.tableRightBorder, classes.tableFont)}
                >
                  <HeaderItem t="NO." />
                  {(props.paginationData?.currentPage - 1) * 10 + (index + 1)}
                </TableCell>
                <TableCell className={clsx(classes.tableRightBorder, classes.tableFont)}>
                <HeaderItem t="MENTOR IMAGE" />
                <div className="newuserTooltip">
                    <Link
                      style={{ color: "#277acc", textDecoration: "underline" }}
                      onClick={() => {
                        let sample;
                        
                        const currentRoute = window.location.href;
                        sample = currentRoute.slice(
                          0,
                          currentRoute.lastIndexOf("/")
                        );
                        let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(datum?.email,PROFILE_KEY)}`, "_blank");

                        // let reRoute = window.open(
                        //   `/mentor-profile/${datum?.email}`,
                        //   "_blank"
                        // );
                        reRoute.id = datum?.email;
                      }}
                    >
                      <img
                        src={datum?.image || hashImage}
                        style={{
                          height: "100px",
                          width: "100px",
                          maxWidth: "none",
                          objectFit: "contain",
                        }}
                      />
                    </Link>
                    <span className="tooltiptext tooltip-bottom" style={{ left: "50px", top: "90px",width:"150px" }}>
                        View Mentor Profile
                      </span>
                      </div>
                </TableCell>
                <TableCell
                  className={clsx(classes.tableRightBorder, classes.tableFont)}
                >
                  <HeaderItem t="MENTOR NAME" />
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      justifyContent: "space-between",
                      height: "100px",
                      // maxWidth: "240px",
                    }}
                  >
                    
                      <Link
                        style={{
                        cursor:"default",
                        color:"black",
                          // textDecoration: "underline",
                        }}
                        // onClick={() => {
                        //   let sample;
                        //   
                        //   const currentRoute = window.location.href;
                        //   sample = currentRoute.slice(
                        //     0,
                        //     currentRoute.lastIndexOf("/")
                        //   );
                        //   let reRoute = window.open(
                        //     `/mentor-profile/${datum?.email}`,
                        //     "_blank"
                        //   );
                        //   reRoute.id = datum?.email;
                        // }}
                      >
                        {datum?.applicant_name}
                      </Link>
                     
                    <div className="newuserTooltip">
                      <div
                        className="d-flex justify-content-end "
                        style={{
                          cursor: "pointer",

                          alignItems: "end",
                          justifyContent: "center",
                          height: "100px",
                          width: "40px",
                          display: "flex",
                        }}
                      >
                        <img
                          src={profile}
                          onClick={() => {
                            let sample;
                            
                            const currentRoute = window.location.href;
                            sample = currentRoute.slice(
                              0,
                              currentRoute.lastIndexOf("/")
                            );
                            let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(datum?.email,PROFILE_KEY)}`, "_blank");

                            // let reRoute = window.open(
                            //   `/mentor-profile/${datum?.email}`,
                            //   "_blank"
                            // );
                            reRoute.id = datum?.email;
                          }}
                        />
                      </div>
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "20px", top: "105px",width:"150px" }}
                      >
                        View Mentor Profile
                      </span>
                    </div>
                  </div>
                  {/* </Tooltip> */}
                </TableCell>
                <TableCell
                  className={clsx(classes.tableRightBorder, classes.tableFont)}
                >
                  <HeaderItem t="DESIGNATION" />
                  {datum?.current_designation}
                </TableCell>
                <TableCell
                  className={clsx(classes.tableRightBorder, classes.tableFont)}
                >
                  <HeaderItem t="COMPANY" />
                  {datum?.organization_name}
                </TableCell>
                <TableCell
                  className={clsx(classes.tableRightBorder, classes.tableFont)}
                >
                  <HeaderItem t="CITY" />
                  {datum?.city}
                </TableCell>
                <TableCell
                  style={{ display: "flex", justifyContent: "center" }}
                  className={clsx(classes.tableRightBorder, classes.tableFont)}
                  onClick={() => {
                    setChatData(datum);
                    setChatId(datum?.id);
                    setChatBoxModalOpen(true);
                    
                  }}
                >
                  <HeaderItem t="SEND MESSAGE" />
                  <div
                    className="d-flex justify-content-end newuserTooltip"
                    style={{
                      cursor: "pointer",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100px",
                      width: "40px",
                      display: "flex",
                    }}
                  >
                    <img
                      src={buttonSendMessage}
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ top: "80px",width:"130px", left: "25px" }}
                    >
                      Send Message
                    </span>
                  </div>
                </TableCell>
                <TableCell
                  className={clsx(classes.tableRightBorder, classes.tableFont)} 
                  style={{position:"relative",left:"1.7rem"}}
                  // style={{ display: "flex", justifyContent: "center" }}
                  // className={clsx(classes.tableRightBorder, classes.tableFont)}
                >
                  <HeaderItem t="MENTORSHIP" />
                 <div
                    className="d-flex justify-content-end newuserTooltip"
                    style={{
                      cursor: "pointer",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100px",
                      width: "40px",
                      display: "flex",
                    }}
                  >
                    <img
                      src={engagementIcon}
                      onClick={()=>  window.open(
                        `/startup-dashboard/mentorships/engagement-summary/${datum?.mentorship?.id}`,
                        "_blank"
                      )}
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ top: "80px",
                        left: "19px",
                        width: "140px",
                        height: "50px", }}
                    >
                     View Engagement Summary
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      ) : (
        <>
                  <tr colSpan={8} style={{ border: "none" }}>
                    <td
                      className="d-flex justify-content-center"
                      style={{ border: "none" }}
                    >
                      {" "}
                      <div
                        className="no-records"
                        style={{
                          position: "relative",
                          left: "28rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        No Records Found
                      </div>
                    </td>
                  </tr>
                </>
      )}
      
      <ChatBoxModal
        modalVisibility={chatBoxModalOpen}
        setModalVisibility={setChatBoxModalOpen}
        receiverInfo={chatdata}
        receiverId={chatId}
      />
    </Box>
  );
}
